if (!window.headerScriptLoaded) {
  window.headerScriptLoaded = true;

  const closeHeaderMenus = () => document.querySelectorAll('header-menu').forEach((menu) => menu.close());

  // Navigation analytics. Elements opt in with data-nav-event / data-nav-value (and optionally data-nav-context).
  document.addEventListener('click', (event) => {
    const trackedElement = event.target.closest('[data-nav-event]');
    if (trackedElement) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'site_interaction',
        context: trackedElement.dataset.navContext || 'navigation',
        action: trackedElement.dataset.navEvent,
        value: trackedElement.dataset.navValue,
      });
    }

    if (event.target.closest('.header-scrim')) closeHeaderMenus();
  });

  // Hover-opened menus never receive focus, so global.js's Escape handler can't reach them
  document.addEventListener('keyup', (event) => {
    if (event.code?.toUpperCase() === 'ESCAPE') closeHeaderMenus();
  });

  // Bump the cart count once whenever it changes. Cart updates re-render the bubble's markup.
  const initCartCountBump = () => {
    const icons = document.querySelector('.header__icons');
    if (!icons) return;

    const readCount = () => icons.querySelector('.cart-count-bubble')?.textContent.trim() ?? '';
    let lastCount = readCount();

    new MutationObserver(() => {
      const count = readCount();
      if (count === lastCount) return;
      lastCount = count;

      const bubble = icons.querySelector('.cart-count-bubble');
      if (!bubble) return;
      bubble.classList.remove('cart-count-bubble--bump');
      void bubble.offsetWidth; // restart the animation if it is already running
      bubble.classList.add('cart-count-bubble--bump');
      bubble.addEventListener('animationend', () => bubble.classList.remove('cart-count-bubble--bump'), {
        once: true,
      });
    }).observe(icons, { childList: true, subtree: true, characterData: true });
  };

  initCartCountBump();
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('section-header')) initCartCountBump();
  });
}
